<h2 mat-dialog-title>
    {{headerTitle}}
    <button mat-icon-button class="close-button" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</h2>

<div mat-dialog-content class="scroll-content">
    <ng-template #target></ng-template>
</div>

<!-- <div fxLayout="column" fxLayoutAlign="center" class="eig-action mat-action-row" *ngIf="!hideFooter">
    <button class="eig-res-btn-l" type="button" mat-button mat-dialog-close>
        {{'button_title.close' | translate}}
    </button>
</div> -->
